import React from 'react'

export default function ServiceManagementData() {
  return (
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M59.0281 30.666C59.0274 35.9782 57.5331 41.1829 54.7152 45.6864C51.8977 50.1895 47.8702 53.8095 43.0931 56.1329C38.3162 58.4564 32.9818 59.3892 27.6998 58.8254C22.4177 58.2617 17.4007 56.2235 13.2217 52.9442" stroke="url(#paint0_linear_4471_7355)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5002 33.222C2.4252 32.3889 2.3877 31.5367 2.3877 30.6659C2.38685 25.0944 4.02945 19.6465 7.10992 15.0041C10.1904 10.3617 14.5718 6.73114 19.7056 4.56682C24.8395 2.40253 30.4978 1.80068 35.972 2.83663C41.4463 3.87257 46.4935 6.50029 50.4813 10.3909" stroke="url(#paint1_linear_4471_7355)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M50.7344 50.6904L72.6562 72.6561" stroke="url(#paint2_linear_4471_7355)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M72.6566 19.7531V4.6875H57.6348" stroke="url(#paint3_linear_4471_7355)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.34375 51.5625L28.3437 25.5719C28.8991 25.0179 29.6515 24.7068 30.4359 24.7068C31.2204 24.7068 31.9728 25.0179 32.5281 25.5719L40.1719 33.2188C40.4466 33.4938 40.7725 33.7119 41.1316 33.8609C41.4906 34.0097 41.8753 34.0866 42.2641 34.0866C42.6528 34.0866 43.0375 34.0097 43.3966 33.8609C43.7556 33.7119 44.0816 33.4938 44.3563 33.2188L72.6562 4.6875" stroke="url(#paint4_linear_4471_7355)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_4471_7355" x1="36.1249" y1="30.666" x2="36.1249" y2="58.9854" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint1_linear_4471_7355" x1="26.4345" y1="2.34277" x2="26.4345" y2="33.222" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint2_linear_4471_7355" x1="61.6953" y1="50.6904" x2="61.6953" y2="72.6561" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint3_linear_4471_7355" x1="65.1457" y1="4.6875" x2="65.1457" y2="19.7531" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint4_linear_4471_7355" x1="37.5" y1="4.6875" x2="37.5" y2="51.5625" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
      </defs>
    </svg>
  )
}
